import { SET_UTM_PARAMS, CLEAR_UTM_PARAMS } from './mutation-types';

export default {
  [SET_UTM_PARAMS](state, params) {
    state.params = params;
  },
  [CLEAR_UTM_PARAMS](state) {
    state.params = null;
  },
};
